<template>
<div>
    <Row >
        
    <Col span="12">
    <Form ref="form" :model="forms" :rules="formRules" :label-width="120">
        <form-header name="基本信息" label="表单的基本信息"></form-header>
        <FormItem label="景点名称" prop="title">
            <Input v-model="forms.title"  placeholder="请输入景点名称"></Input>
        </FormItem>
         <FormItem label="景点图片" prop="image">
            <uploadFile v-model="forms.image" type='image' ></uploadFile>
            <div>图片尺寸最低750*544像素</div>
        </FormItem>
        <FormItem label="景点图标" prop="icon">
            <uploadFile v-model="forms.icon" type='image' ></uploadFile>
            <div>图片尺寸最低75*75像素</div>
        </FormItem>
        <!-- <FormItem label="景点图集" prop="image">
            <uploadFile v-model="forms.gallery" type='image' :multiple="true"></uploadFile>
            <div>图片尺寸最低750*462像素</div>
        </FormItem> -->
        <FormItem label="类型" prop="type">
            <Select v-model="forms.type"   style="width:200px">
                <Option :value="1" >大门</Option>
                <Option :value="2" >景点</Option>
                <Option :value="3" >卫生间</Option>
                <Option :value="4" >便利店</Option>
                <!-- <Option :value="7" >卫生间</Option>
                <Option :value="8" >入口</Option>
                <Option :value="9" >出口</Option>
                <Option :value="10" >安全出口</Option> -->
            </Select>
        </FormItem>
        <FormItem label="语音简介" prop="audio">
            <uploadFile v-model="forms.audio" type='audio' ></uploadFile>
        </FormItem>
         <FormItem label="地址" prop="address" >
             <Input v-model="forms.address" icon="ios-paper-plane"  placeholder="请输入地址">
                    <span slot="append" style="color: blue;cursor: pointe;" @click="btns">地图</span>
             </Input>
        </FormItem>
        <FormItem label="经纬度" prop="lnglat" >
             <Input v-model="forms.lnglat"   placeholder="请输入经纬度" ></Input>
        </FormItem>
        <div v-if="mod==true">
            <formAddress :value="this.forms.lnglat" @setAddress ="onAddress" @cancel="onCancel"></formAddress>
        </div>
        <FormItem label="简介" prop="content" >
            <Input v-model="forms.content" type="textarea" :autosize="{minRows: 5}" placeholder="请输入简介"></Input>
        </FormItem>
         <FormItem label="详情" prop="detail" >
          <!-- <formEditor v-model="forms.detail" :config="v.config || {}" :zIndex="v.zIndex" :disabled="v.disabled"></formEditor> -->
          <formEditor v-model="forms.detail" :config="this.config || {}" :zIndex="999" ></formEditor>
        </FormItem>
        <button-box>
            <button-sub @click="handleSubmit" :loading="sloading"></button-sub>
            <button-back></button-back>
        </button-box>
    </Form>
    </Col>
    </Row>
    
</div>
</template>
<script>
import baseView from '@/views/components/base/baseView.vue'
import formAddress from '../components/common/form/formMap'
import formEditor from '../components/common/form/formEditor'
    export default {
        extends: baseView,
        components: { formAddress,formEditor },
        data () {
            return {
                mod:false,
                index: 1,
                sloading: false,
                action: 'add',
                mname: 'spot',
                address:'',
                kv: '',
                url: {},
                forms: {
                    title:'',
                    type:'',
                    image:'',
                    icon:'',
                    audio:'',
                    address:'',
                    lnglat:'',
                    content:'',
                },
                formRules: {
                    title: [
                        { required: true, message: '景点不能为空', trigger: 'blur' }
                    ],
                    image: [
                        { required: true, message: '图片不能为空', trigger: 'blur' }
                    ],
                    // icon: [
                    //     { required: true, message: '图标不能为空', trigger: 'blur' }
                    // ],
                    type: [
                        { required: true, message: '类型不能为空', trigger: 'blur',type:'number' }
                    ],
                    address: [
                        { required: true, message: '地址不能为空', trigger: 'blur' }
                    ],
                }
            }
        },
        created () {
            let query = this.$route.query
            console.log(query);
            
            if(query.action === 'edit'){
                this.kv = query.kv
                this.action = query.action
                this.getInfo()
            }
        },
        methods: {
            btns(){
                this.mod = true
                this.address = this.forms.address
            },
            onAddress(val,e){
                console.log("onAddress",val,e)
                this.forms.address = val
                this.forms.lnglat = e.join(",")
                
                 this.mod = false
            },
            onCancel(){
                console.log('4444444');
                this.mod = false
            },
       
            
                
            // 查询信息
             getInfo () {
                let d ={}
                d.kv = this.kv
                 $utils.api.load('spotGet', d).then(res => {
                     this.forms = res.data
                 })
               
            },
       
            initData() {
                $form.initData(this)
            },
            handleSubmit () {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        $form.handleSubmit(this)
                    }
                })
            },
            
        }
    }
</script>
<style lang="less" scoped>
</style>

